<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0"> گزارش وضیعت دستگاه های دبیربد  </h5>
     <br/>
     <br>

     <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">تاریخ شروع</label>
        <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">تاریخ پایان</label>
        <input type="text" #datepickerInputEnd  placeholder="اینجا تایپ کنید ..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">نام مشتری </label>
        <input [(ngModel)]="Name" type="text" class="form-control"  placeholder="برای جستجوی اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">عنوان دستگاه</label>
        <input [(ngModel)]="Code" type="text" class="form-control"  placeholder="برای جستجوی اینجا تایپ کنید ...">
      </div>
    </div>

     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_DeviceInLetter(datepickerInputStart.value,datepickerInputEnd.value)"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
        style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام دستگاه</th>
              <th>پیش فاکتور</th>
              <th>زمانبندی شده</th>
              <th>رسیده شده</th>
              <th>بررسی گواهی نامه</th>
              <th>تایید گواهی نامه</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceInLetter
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceInLetter).length
                      }
            ">
              <td>{{DataList_DeviceInLetter.indexOf(item)+1}}</td>
              <td>{{item['title']}}</td>
              <td>{{item['preOrder']}}</td>
              <td>{{item['submitOrder']}}</td>
              <td>{{item['calibration']}}</td>
              <td>{{item['certificate']}}</td>
              <td>{{item['certificate_confirm']}}</td>
            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Customer"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>


<table  id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>نام دستگاه</th>
      <th>پیش فاکتور</th>
      <th>زمانبندی شده</th>
      <th>رسیده شده</th>
      <th>بررسی گواهی نامه</th>
      <th>تایید گواهی نامه</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_DeviceInLetter
    | paginate
            : {
                id: 'DataList_Customer',
                itemsPerPage: 50,
                currentPage: page,
                totalItems: (DataList_DeviceInLetter).length
              }
    ">
      <td>{{DataList_DeviceInLetter.indexOf(item)+1}}</td>
      <td>{{item['title']}}</td>
      <td>{{item['preOrder']}}</td>
      <td>{{item['submitOrder']}}</td>
      <td>{{item['calibration']}}</td>
      <td>{{item['certificate']}}</td>
      <td>{{item['certificate_confirm']}}</td>
    </tr>
  </tbody>
</table>